import React from 'react'
import { useAppContext, User } from '../providers/context'
import { SimpleLayout } from '../layouts/simple'
import { SpecialPanel } from '../layouts/components/panel'
import { Button } from '../components/simple/button'
import { onIOS, onSafari } from '../utils'
import { Toasts } from '../providers/toast'
import { useNotifications } from '../providers/pushNotificationProvider'
export const PushNotificationSetupPage: React.FC<{ user: User }> = ({ user }) => {
  const { notificationsEnabled, toggleNotifications, sendTestNotification } = useNotifications()
  const { state } = useAppContext()

  const [showAdditionalHelp, setShowAdditionalHelp] = React.useState(false)
  const [sendingTestNotification, setSendingTestNotification] = React.useState(false)
  const [loading, setLoading] = React.useState(false)

  return (
    <SimpleLayout>
      <SpecialPanel>
        <div className="text-xl font-bold">Configure Browser Push Notifications</div>
        <div>
          <b>You can now receive a notification whenever you receive a new message!</b>
          <br /> These notifications will popup in your browser or phone and you can click them to quickly see and
          respond to your latest message. You will need to enable notifications on each device you want to receive them
          on.
        </div>
        <Button
          disabled={loading}
          logo
          onClick={async () => {
            setLoading(true)
            setShowAdditionalHelp(await toggleNotifications())
            setLoading(false)
          }}
        >
          {notificationsEnabled ? 'Disable notifications' : 'Enable notifications'}
        </Button>
        <div>Status: {notificationsEnabled ? 'Notifications enabled' : 'Notifications disabled'}</div>
        {notificationsEnabled && (
          <Button
            disabled={sendingTestNotification}
            logo
            onClick={async () => {
              Toasts.showToast({ message: 'A test notification will be sent in 10 seconds' })
              setSendingTestNotification(true)
              await sendTestNotification()
              setSendingTestNotification(false)
            }}
          >
            Send a test notification
          </Button>
        )}
        {showAdditionalHelp && !notificationsEnabled && (
          <div>
            If a popup does not appear asking if you want to enable notifications, you may need to manually enable them
            in your browser settings.
            {onIOS && onSafari && (
              <div className="mt-3">
                <h6>
                  Notifications are a little more complicated to enable on iOS Safari. Make sure the following steps
                  have been completed
                </h6>
                <ul>
                  <li>First make sure you are using iOS 16.4 or later</li>
                  <li>
                    Save the {state.appName} home page to your homescreen, by pressing{' '}
                    <i>share {'>'} add to home screen</i> at the bottom of the browser tab (see the bottom of this page
                    for more details).
                  </li>
                  <li>Close this tab and open the app from your homescreen. You may need to sign in again.</li>
                  <li>
                    Navigate back to this page and click the <i>Enable Notifications</i> button above. Allow
                    notifications in the popup that appears. Sometimes you will have to restart this app after
                    completing this step
                  </li>
                  <li>
                    If notifications still dont work, try enabling <b>notifications</b>, <b>push api</b>, and{' '}
                    <b>service workers</b> in experimental features under advanced settings for Safari in the settings
                    app .
                  </li>
                </ul>

                <img src="/images/iphoneS1.png" height="400px" />
                <img src="/images/iphoneS2.png" height="400px" className="mt-2" />
              </div>
            )}
          </div>
        )}
      </SpecialPanel>
    </SimpleLayout>
  )
}
